/* eslint-disable react-native/no-inline-styles */
import React, {useState, useEffect} from 'react';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import useWebinarApi from '@/Hooks/WebinarApi/useWebinarApi';
import Pagination from '../../Games/Pagination';
import CCLoader from '@/Atoms/CCLoader/CCLoader';
import CCPackageTable from '@/Atoms/CCPackageTable';
import CCText from '@/Atoms/CCText';
import Box from '@/Atoms/Box';
import Spacer from '@/Atoms/Spacer';
import {
  ScrollView,
  Pressable,
  Image,
  Linking,
  StyleSheet,
  View,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import CCColors from '@/Utils/CCColors';
import {FontSizes, hs, vs} from '@/Utils/Dimensions';
import CCButton from '@/Atoms/CCButton/CCButton';
import {TouchableOpacity} from 'react-native-gesture-handler';
import {
  convertISTDateTimeToLocal,
  convertISTToUserTimezone,
  getUTCOffset,
  openInNewTab,
  setLocalStorage,
} from '@/Utils/CommonUtils';
import useWebinarHeldApi from '@/Hooks/WebinarApi/useWebinarHeldApi';
import useCancelSessionApi from '@/Hooks/WebinarApi/useCancelSessionApi';
import SlideModal from '@/Atoms/SlideModal';
import {PopUp} from '@/Screens/Visualisation/components/LevelModal';
import {ActiveMeetingsModal} from './ActiveMeetingsModal';
import {CancelSessionModal} from './CancelSessionModal';
import useClassroomJoin from '@/Hooks/ClassroomInfoApi/useClassroomJoin';
import LinkModal from './LinkPopup';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import MeetingsBanner from './MeetingsBanner';
import RenewalBanner from '@/Screens/Renewal/components/RenewalBanner';
import useGetRenewalForUser from '@/Hooks/RenewalApi/useGetRenewalForUser';
import {ScreenName} from '@/navigators/StackConstants';
import {useNavigation} from '@react-navigation/native';
import {TabBar, TabView} from 'react-native-tab-view';
import {Picker} from '@react-native-picker/picker';
import dayjs from 'dayjs';
import {getStatusStyles} from './MentorCalls';
import useCTActionApi from '@/Hooks/CTActionApi/CTActionApi';
import RescheduleModal, {AvailableSlots} from './RescheduleModel';
import useCoachAvailabilitySlots from '@/Hooks/WebinarApi/useCoachAvailableSlots';
import useRescheduleSessionApi from '@/Hooks/WebinarApi/useRescheduleSession';
import useGetAvailableSlots from '@/Hooks/MentorCallsApi/getAvailableSlots';
import useRescheduleMentorCall from '@/Hooks/MentorCallsApi/rescheduleMentorCall';
import Divider from '@/Atoms/Divider/Divider';
import {LinearGradient} from 'expo-linear-gradient';
import Tooltip from '@/Atoms/Tooltip';
import bookOpen from '../../../Assets/Images/Svgs/book-open.svg';
import bookCheck from '../../../Assets/Images/Svgs/book-check.svg';
import useAlertModalStore from '@/Store/AlertModalStore';

// const tabHeadersWithClassroom = [
//   'Webinar topic',
//   'Coach',
//   'Class Type',
//   'Webinar date',
//   'Webinar time',
//   'Classroom',
//   'Webinar URL',
// ];

const tabHeaders = [
  'Date',
  'Topic & Coach',
  'Time',
  'Class Type',
  'Status',
  // 'Classroom',
  '', // contains button and cancel x
];

const Meetings: React.FC<any> = ({
  userKey,
  userContact,
  userData,
  setPopupBlocked,
}) => {
  // Detect user timezone (fallback to IST)
  const userTimezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Kolkata';
  const [webinarLoading, setWebinarLoading] = useState(true);
  const [webinarData, setWebinarData] = useState([]);
  const [pastWebinarData, setPastWebinarData] = useState([]);
  const [webinarDetails, setWebinarDetails] = useState([]);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [sessionClick, setSessionClick] = useState(false);
  const [pastWebinarId, setPastWebinarId] = useState(null);
  const [popupText, setPopupText] = useState('');
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelSessionData, setCancelSessionData] = useState<any>(null);
  const [index, setIndex] = useState(0);
  const [isTabChanging, setIsTabChanging] = useState(false);
  console.log('webinarDetails: ', webinarDetails);
  const [showStatusBar, setShowStatusBar] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [pendingJoinData, setPendingJoinData] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const [statusBarData, setStatusBarData] = useState(null);
  const [toRoute, setRoute] = useState<(() => void) | null>(null);
  const [toRoute1, setRoute1] = useState<(() => void) | null>(null);
  const [toRoute2, setRoute2] = useState<(() => void) | null>(null);
  const [action1, setAction1] = useState('');
  const [action2, setAction2] = useState('');
  const [todayWebinarIds, setTodayWebinarIds] = useState<Set<string>>(
    new Set(),
  );
  const [callId, setCallId] = useState('');
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [isMentorCall, setIsMentorCall] = useState(false);
  const [coachAvailableSlots, setCoachAvailableSlots] =
    useState<AvailableSlots>();
  const openAlertModal = useAlertModalStore(state => state.openModal);
  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState(false);
  const [rescheduleSessionResponse, setRescheduleSessionResponse] =
    useState<any>();
  const [visible, setVisible] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [showRenewalBanner, setShowRenewalBanner] = useState(true);
  // console.log('userData: ', userData.is_staff);
  
  // Get renewal data for banner - user ID extracted from auth token
  const {data: renewalData, isLoading: isLoadingRenewal} = useGetRenewalForUser();

  // Show renewal banner if eligible
  useEffect(() => {
    if (renewalData?.banner?.should_show) {
      setShowRenewalBanner(true);
    }
  }, [renewalData]);

  // Define your color array
  const STATUS_BAR_COLORS = [
    CCColors.StatusBar.PinkShade,
    CCColors.StatusBar.Blue,
    CCColors.StatusBar.Orange,
    CCColors.StatusBar.Green,
  ];
  const TEXT_COLORS = [
    CCColors.StatusBar.DarkPink,
    CCColors.StatusBar.DarkBlue,
    CCColors.Red,
    CCColors.Green,
  ];
  // In your component
  const [colorIndex, setColorIndex] = useState(2);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setColorIndex(prevIndex => (prevIndex + 1) % STATUS_BAR_COLORS.length);
  //   }, 500); // Change color every 3 seconds

  //   return () => clearInterval(interval);
  // }, []);

  const [statusBanner, setStatusBanner] = useState({
    icon: 'information-outline',
    iconBg: '',
    title: '',
    subTitle: '',
    ctaTitle: '',
    closeIcon: false,
    iconColor: '',
    id: 0,
    ctaAction: '',
    link: '',
    highlight: 0,
  });
  const [popupConfig, setPopupConfig] = useState({
    icon: 'information-outline',
    questionText: '',
    subQuestionText: '',
    cta1: {
      text: '',
      highlight: false,
      link: '',
    },
    cta2: {
      text: '',
      highlight: false,
      link: '',
    },
    id: 0,
  });
  const navigation = useNavigation();
  const ICON_MAP = {
    warning: {
      name: 'exclamation',
      bgColor: CCColors.WrongMoves.Background,
      iconColor: CCColors.RedBg,
    },
    info: {name: 'information-variant', bgColor: CCColors.Primary.Dark},
    error: {
      name: 'close',
      bgColor: CCColors.WrongMoves.Background,
      iconColor: CCColors.RedBg,
    },
    alert: {
      name: 'exclamation-thick',
      bgColor: CCColors.WrongMoves.Background,
      iconColor: CCColors.RedBg,
    },
  };
  const handleConfirmJoin = () => {
    if (pendingJoinData) {
      // console.log(pendingJoinData, 'pendingJoinData');

      const opened = handleJoinClick(pendingJoinData); // ✅ only runs when Confirm is clicked
      if (opened === false) {
        setPopupBlocked(true);
      } else {
        setPendingJoinData(null);
      }
    }
    setShowPopup(false);
  };
  const ROUTE_MAP = {
    view_assessment: () => navigation.navigate(ScreenName?.AssessmentReport),
    view_dashboard: () => navigation.navigate(ScreenName?.Dashboard),
    tournament_list: () =>
      navigation.navigate(ScreenName?.Tournaments, {
        from: 'tournaments',
      }),
    position_trainer: () => navigation.navigate(ScreenName?.Puzzles),
    game_review_list: () => navigation.navigate(ScreenName?.Games),
    viz_trainer: () => navigation.navigate(ScreenName?.Visualisation),
    rules_n_rewards: () => navigation.navigate(ScreenName?.Rewards),
    meeting_recordings: () =>
      navigation.navigate(ScreenName?.Books, {tab: 'video_courses'}),
    assignment_list: () =>
      navigation.navigate(ScreenName?.Books, {tab: 'user_assignment'}),
    mentor_calls: () =>
      navigation.navigate(ScreenName?.Books, {tab: 'mentor_calls'}),
    csoc_subscription: () =>
      navigation.navigate(ScreenName?.Books, {tab: 'subscription'}),
    cc_league_home: () =>
      navigation.navigate(ScreenName?.Books, {tab: 'ccLeague'}),
    caissa_subscription: () => navigation.navigate(ScreenName?.Subscription),
  };

  const handleCTA1Press = () => {
    if (toRoute1) {
      toRoute1();
      setShowPopup(false);
    } else if (action1 === 'continue_join') {
      handleConfirmJoin();
    } else if (action1 === 'link') {
      window.open(popupConfig?.cta1?.link, '_blank');
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
    popupAction({
      popup_id: popupConfig?.id,
      mobile_number: userContact,
      cta_action: action1,
    });
  };
  const handleCTA2Press = () => {
    if (toRoute2) {
      toRoute2();
      setShowPopup(false);
    } else if (action2 === 'continue_join') {
      handleConfirmJoin();
    } else if (action2 === 'link') {
      window.open(popupConfig?.cta2?.link, '_blank');
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
    popupAction({
      popup_id: popupConfig?.id,
      mobile_number: userContact,
      cta_action: action2,
    });
  };
  const routes = [
    {key: 'Meetings', title: 'Meetings'},
    {key: 'Upcoming Meetings', title: 'Upcoming Meetings'},
  ];
  // Use shared classroom join hook
  const {
    showActiveMeetingsModal,
    activeMeetingsCount,
    activeLoading,
    endLoading,
    handleJoinClick,
    handleModalClose,
    handleModalJoin,
    handleModalEndAndJoin,
  } = useClassroomJoin();

  const handleOnSuccessWebinarDetails = data => {
    setWebinarData(data?.data?.webinar_list);
    setPastWebinarData(data?.data?.past_webinar_list);
    setWebinarDetails(data?.data);
    setWebinarLoading(false);
    setPopupData(data?.data?.popup_message);
    setStatusBarData(data?.data?.status_message);
  };
  useEffect(() => {
    if (statusBarData) {
      setRoute(() => ROUTE_MAP[statusBarData?.cta_details?.[0]?.action]);
      const iconConfig = ICON_MAP?.[statusBarData?.icon] ?? {};
      setShowStatusBar(true);
      setStatusBanner({
        icon: iconConfig?.name,
        iconBg: iconConfig?.bgColor,
        title: statusBarData?.main_text
          ? statusBarData.main_text.charAt(0).toUpperCase() +
            statusBarData.main_text.slice(1)
          : '',
        subTitle: statusBarData?.sub_text
          ? statusBarData.sub_text.charAt(0).toUpperCase() +
            statusBarData.sub_text.slice(1)
          : '',
        ctaTitle: statusBarData?.cta_details?.[0]?.text || '',
        ctaAction: statusBarData?.cta_details?.[0]?.action || '',
        closeIcon: statusBarData?.close_icon,
        iconColor: CCColors.White,
        id: statusBarData?.id,
        link: statusBarData?.cta_details?.[0]?.link || '',
        highlight: statusBarData?.cta_details?.[0]?.highlight || 0,
      });
    }
  }, [statusBarData]);
  const handleOnSuccessWebinarHeld = data => {
    console.log('marked successfully', data);
    if (data?.data?.success) {
      setPastWebinarData(prev =>
        prev.filter(item => item?.id !== pastWebinarId),
      );
    } else {
      setShowErrorAlert(true);
      setPopupText('Please try again later');
    }
  };
  const handleOnErrorWebinarUnheld = error => {
    console.log('error in marking webinar held', error);
    if (error) {
      setShowErrorAlert(true);
      setPopupText(error?.response?.data?.error);
    }
  };
  const {mutate: getWebinarDetails, isLoading: isWebinarLoading} =
    useWebinarApi(handleOnSuccessWebinarDetails);
  const {mutate: markWebinarHeld, isLoading} = useWebinarHeldApi(
    handleOnSuccessWebinarHeld,
    handleOnErrorWebinarUnheld,
  );
  const {mutate: popupAction} = useCTActionApi(() => {
    console.log('Popup action updated successfully!');
  });

  const handleOnSuccessCancelSession = data => {
    console.log('Session cancelled successfully', data);
    if (data?.data?.success) {
      // Close the modal and show success message
      setShowCancelModal(false);
      setCancelSessionData(null);
      setPopupText('Session cancelled successfully');
      setShowErrorAlert(true);

      // Refetch the webinar list to get updated data including finding_substitute flag
      getWebinarDetails({user_key: userKey, timezone: getUTCOffset()});
    } else {
      setShowErrorAlert(true);
      setPopupText(data?.data?.message || 'Failed to cancel session');
    }
  };

  const handleOnErrorCancelSession = error => {
    console.log('error in cancelling session', error);
    if (error) {
      setShowErrorAlert(true);
      setPopupText(
        error?.response?.data?.message || 'Failed to cancel session',
      );
    }
  };

  const {mutate: cancelSession, isLoading: isCancelling} = useCancelSessionApi(
    handleOnSuccessCancelSession,
    handleOnErrorCancelSession,
  );

  const handleCancelClick = (item: any) => {
    // Determine cancellation type based on batch_code
    // Personal sessions: batch_code contains '-p-' OR call_type is 'mentor_call'
    // Group sessions: batch_code exists but doesn't contain '-p-'
    const isPersonal =
      (item?.batch_code && item?.batch_code?.toLowerCase()?.includes('-p-')) ||
      item?.call_type === 'mentor_call';
    const cancellationType = isPersonal ? 'personal' : 'group';

    // Determine user role (coach vs student/parent)
    const userRole =
      item?.user_type === 'coach' || item?.user_role === 'mentor'
        ? 'coach'
        : 'student';
    setUserRole(userRole);
    setCancelSessionData({
      id: item?.id,
      topic: item?.topic,
      date: item?.webinar_date,
      time: item?.webinar_time,
      cancellation_type: cancellationType,
      user_type: item?.user_type, // Store user type for role determination
      batch_code: item?.batch_code || '', // Pass batch code for limit checking
      user_role: userRole, // Pass user role for limit checking
    });
    setShowCancelModal(true);
  };

  const {
    mutate: rescheduleMentorCall,
    isLoading: isRescheduleMentorCallLoading,
  } = useRescheduleMentorCall(
    data => {
      setRescheduleSessionResponse(data);
      getWebinarDetails({user_key: userKey, timezone: getUTCOffset()});
      const timer = setTimeout(() => {
        setShowRescheduleModal(false);
        clearTimeout(timer);
      }, 1000);
    },
    error => {
      setRescheduleSessionResponse(error);
    },
  );

  const {mutate: rescheduleSession, isLoading: isRescheduleSessionLoading} =
    useRescheduleSessionApi(
      data => {
        setRescheduleSessionResponse(data);
        getWebinarDetails({user_key: userKey, timezone: getUTCOffset()});
        const timer = setTimeout(() => {
          setShowRescheduleModal(false);
          clearTimeout(timer);
        }, 1000);
      },
      error => {
        setRescheduleSessionResponse(error);
      },
    );

  const processAvailability = data => {
    const slots = data?.result?.[0]?.slots ?? [];

    // API sends times in IST - convert to user's local timezone for display
    const grouped = slots.reduce((acc, slot) => {
      // Convert IST times from API to user's local timezone
      const startTime = convertISTToUserTimezone(slot.start_time);
      const endTime = convertISTToUserTimezone(slot.end_time);

      // Extract date for grouping (in user's timezone)
      const dateKey = startTime.split('T')[0];

      console.log('Original IST:', slot.start_time);
      console.log('User TZ:', startTime);

      const timeSlot = {
        id: slot.id,
        start_time: startTime,
        end_time: endTime,
        is_available: slot.is_available,
        blocked_reason: slot.blocked_reason,
        original_start_time: slot.start_time,
      };

      if (!acc[dateKey]) {
        acc[dateKey] = [];
      }
      acc[dateKey].push(timeSlot);
      return acc;
    }, {});

    console.log('Grouped slots', grouped);
    setCoachAvailableSlots(grouped);
  };

  const {mutate: getCoachAvailability, isLoading: isCoachSlotsLoading} =
    useCoachAvailabilitySlots(
      data => processAvailability(data),
      error => {
        console.log(error, 'mentor calls error');
      },
    );
  const {mutate: getMentorAvailability, isLoading: isMentorSlotsLoading} =
    useGetAvailableSlots(
      data => processAvailability(data),
      error => {
        console.log(error, 'mentor calls error');
      },
    );

  const handleReschedule = (item: any) => {
    console.log(item);
    setRescheduleSessionResponse(null);
    if (item?.id) {
      setShowRescheduleModal(true);
      setCallId(item.id);
      if (item.mentor_id) {
        getMentorAvailability({
          mentor_id: String(item.mentor_id),
          weeks: '2',
        });
        setIsMentorCall(true);
      } else if (item.coach_user_id) {
        // For coach sessions, use 1-hour slots
        getCoachAvailability({
          coach_user_id: item.coach_user_id,
          reschedule_type: 'session',
        });
        setIsMentorCall(false);
      }
    }
  };

  const handleCancelConfirm = (sessionId: number, reason: string) => {
    if (cancelSessionData) {
      // Determine user role (for now defaulting to 'student', you may need to get this from context/props)
      const userRole =
        cancelSessionData.user_type === 'coach' ? 'coach' : 'student';

      cancelSession({
        session_id: sessionId,
        reason: reason,
        cancellation_type: cancelSessionData.cancellation_type,
        user_role: userRole,
      });
    }
  };

  const [enableClassroom, setEnableClassroom] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);

  useEffect(() => {
    getWebinarDetails({user_key: userKey, timezone: getUTCOffset()});
  }, []);

  const paginate = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      getWebinarDetails({
        page: pageNumber,
        user_key: userKey,
        timezone: getUTCOffset(),
      });
    }
  };

  const {isMobileOrTab, isTablet} = useMediaQuery();

  // Transform webinar item to join data format
  const transformToJoinData = (item: any) => ({
    id: item?.id,
    webinar_id: item?.webinar_id,
    registrant_token: item?.registrant_token,
    meeting_password: item?.meeting_password,
    occurence_id: item?.occurence_id,
    meeting_role: item?.meeting_role,
    is_zoom_meeting: item?.is_zoom_meeting,
    batch_type: item?.batch_type,
    webinar_topic: item?.topic,
  });
  const handleJoinPress = item => {
    // Just store the data temporarily and open the popup
    console.log(transformToJoinData(item), 'transformToJoinData(item)');

    setPendingJoinData(transformToJoinData(item));

    // setPopupIcon('');
    // setPopupQText('');
    // setPopupsubQText('');
    // setPopupCtaTitle1('');
    // setPopupCtaTitle2('');
    // setHighlightCta1(false);
    // setHighlightCta2(false);
    setRoute1(null);
    setRoute2(null);

    const popupSource = item?.popup_message
      ? item.popup_message
      : popupData
      ? popupData
      : null;
    if (popupSource) {
      setShowPopup(true);
      if (popupSource?.cta_details?.[0]?.action) {
        setRoute1(() => ROUTE_MAP[popupSource?.cta_details?.[0]?.action]);
        setAction1(popupSource?.cta_details?.[0]?.action);
      }
      if (popupSource?.cta_details?.[1]?.action) {
        setRoute2(() => ROUTE_MAP[popupSource?.cta_details?.[1]?.action]);
        setAction2(popupSource?.cta_details?.[1]?.action);
      }
      setPopupConfig({
        icon: ICON_MAP?.[popupSource?.icon]?.name || '',
        questionText: popupSource?.question_text || '',
        subQuestionText: popupSource?.sub_question || '',
        cta1: {
          text: popupSource?.cta_details?.[0]?.text || '',
          highlight: popupSource?.cta_details?.[0]?.highlight === 1,
          link: popupSource?.cta_details?.[0]?.link,
        },
        cta2: {
          text: popupSource?.cta_details?.[1]?.text || '',
          highlight: popupSource?.cta_details?.[1]?.highlight === 1,
          link: popupSource?.cta_details?.[1]?.link,
        },
        id: popupSource?.id,
      });
    } else {
      const joinData = transformToJoinData(item);
      const opened = handleJoinClick(joinData);
      if (opened === false) {
        setPopupBlocked(true);
      } else {
        setPendingJoinData(null);
      }
    }
  };
  const [upcomingTableData, setUpcomingTableData] = useState<
    Array<{
      data: Array<{
        name: string | JSX.Element;
        type: 'text' | 'link' | 'dropdown';
        url?: string;
        options?: string[];
      }>;
      isToday: boolean;
      itemId: string;
    }>
  >([]);

  const [pastTableData, setPastTableData] = useState<
    Array<{
      data: Array<{
        name: string | JSX.Element;
        type: 'text' | 'link' | 'dropdown';
        url?: string;
        options?: string[];
      }>;
      isToday: boolean;
      itemId: string;
    }>
  >([]);
  const handleStatusBarPress = () => {
    if (toRoute) {
      toRoute();
    } else if (statusBanner?.ctaAction === 'link') {
      window.open(statusBanner?.link, '_blank');
    } else {
      navigation.navigate(ScreenName?.Books, {
        tab: 'meeting',
      });
      setShowStatusBar(false);
    }
    popupAction({
      popup_id: statusBanner?.id,
      mobile_number: userContact,
      cta_action: statusBanner?.ctaAction,
    });
  };
  const handleRecordingPress = item => {
    const url = `${window.location.origin}/${ScreenName.Classroom}`;
    localStorage.setItem(
      'ZoomUserData',
      JSON.stringify({
        meetingId: item?.webinar_id,
        occurenceId: item?.occurence_id,
        meetingRole: 'student',
        videoId: item?.video_id,
        batchType: item.batch_type,
        topic: item.topic,
        recording_available: item?.recording_available,
        source: 'recording',
      }),
    );
    openInNewTab(url);
  };
  const WebinarSection = ({
    isLoading,
    webinarLoading,
    tableData,
    tabHeaders,
    currentPage,
    totalPages,
    paginate,
    webinarDetails,
    cardData,
    isMobileOrTab,
  }) => {
    if (isLoading) {
      return <CCLoader loading={isLoading} isComponentLoader />;
    }
    if (webinarLoading) {
      return <CCLoader loading bgWhite isComponentLoader />;
    }
    const customFlexArr = [0.9, 1.6, 1.6, 1, 1, 2];
    if (tableData?.length > 0) {
      const highlightedRows = tableData
        .slice(0, 3)
        .map((row, idx) => (row.isToday ? idx : -1))
        .filter(idx => idx !== -1);

      // Extract just the data for the table
      const tableDataFormatted = tableData.map(row => row.data || row);
      return (
        <Box flexDirection="column" >
          {/* Renewal Banner */}
          {showRenewalBanner && renewalData && userData?.is_staff && (
            <Box paddingHorizontal={isMobileOrTab ? 10 : 20} marginBottom={15}>
              <RenewalBanner
                daysLeft={Number(renewalData?.current_subscription?.days_to_expiry|| 100)}
                couponDiscountPercentage={Number(renewalData?.coupon?.discount_value) ?? 0}
                // daysLeft={1}
                sessionsLeft={renewalData?.current_subscription?.sessions_left ?? 0}
                couponCode={renewalData?.coupon?.code}
                // onRenewNow={() => {
                //   navigation.navigate(ScreenName.Renewal, {userId});
                // }}
                onClose={() => setShowRenewalBanner(false)}
              />
            </Box>
          )}
          {!isMobileOrTab && showStatusBar && (
            <Box
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-start"
              style={[
                styles.statusBar,
                {
                  backgroundColor: CCColors.Primary.Dark,
                  marginHorizontal: 8,
                },
              ]}>
              <MeetingsBanner
                iconName={statusBanner?.icon}
                iconColor={CCColors.White}
                onClose={() => setShowStatusBar(false)}
                titleText={statusBanner?.title}
                ctaText={statusBanner?.ctaTitle}
                closeIcon={statusBanner?.closeIcon}
                handlePress={handleStatusBarPress}
                borderColor={statusBanner?.iconColor}
                subtitleText={statusBanner?.subTitle}
                highlight={statusBanner?.highlight}
                textColor={CCColors.White}
                isMobileOrTab={isMobileOrTab}
              />
            </Box>
          )}
          <Box style={isMobileOrTab ? styles.mobileTable : styles.table}>
            <CCPackageTable
              headers={tabHeaders}
              tableData={tableDataFormatted ?? []}
              flexArr={customFlexArr}
              borderBottomColor={CCColors.BorderBottom}
              headerTextColor={CCColors.TextColor.Grey}
              margin={0}
              jsxTable={false}
              isMargin={false} // Enables Pressable rows
              tournament={false}
              backgroundColorRow={true}
              tableBorder={false}
              higlightedRow={
                index === 0 && currentPage === 1 ? highlightedRows : null
              }
              highlightedBorder={false}
              tablePadding={true}
              headerHeight={55}
              tableShadow={true}
              customBlockRow={{
                backgroundColor: CCColors.White,
                borderColor: CCColors.BorderBottom,
                padding: 0,
              }}
              customCellBlock={{
                borderBottomWidth: 0,
                padding: 0,
              }}
              isSecondLastRow={true}
            />
          </Box>
          <Box style={{alignSelf: 'flex-start', marginTop: 10, marginLeft: 10}}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              paginate={paginate}
              activeColor={true}
            />
          </Box>
        </Box>
      );
    }

    if (webinarDetails?.expired === 1) {
      return (
        <Box style={{alignItems: 'center', padding: 24, gap: 10}}>
          <CCText
            style={{
              fontSize: 24,
              fontWeight: '500',
              lineHeight: 32,
              textAlign: 'center',
            }}>
            {webinarDetails?.display_message}
          </CCText>

          {webinarDetails?.renewal_web_link && (
            <CCButton
              style={{
                paddingHorizontal: 20,
                paddingVertical: 8,
                borderRadius: 32,
              }}
              onPress={() => Linking.openURL(webinarDetails?.renewal_web_link)}>
              <CCText
                style={{
                  fontSize: 16,
                  fontWeight: '500',
                  lineHeight: 24,
                  color: CCColors?.TextColor?.Dark,
                }}>
                Renew via web
              </CCText>
            </CCButton>
          )}

          {webinarDetails?.renewal_whatsapp_link && (
            <CCButton
              style={{
                paddingHorizontal: 20,
                paddingVertical: 8,
                borderRadius: 32,
              }}
              onPress={() =>
                Linking.openURL(webinarDetails?.renewal_whatsapp_link)
              }>
              <CCText
                style={{
                  fontSize: 16,
                  fontWeight: '500',
                  lineHeight: 24,
                  color: CCColors?.TextColor?.Dark,
                }}>
                Renew via WhatsApp
              </CCText>
            </CCButton>
          )}
        </Box>
      );
    }

    if (webinarDetails?.expired === 0) {
      return (
        <Box style={{alignItems: 'center', padding: 24}}>
          <CCText
            style={{
              fontSize: 24,
              fontWeight: '500',
              lineHeight: 32,
              textAlign: 'center',
            }}>
            Try School of Chess now
          </CCText>
          <CCText
            style={{
              fontSize: 16,
              fontWeight: '400',
              lineHeight: 24,
              textAlign: 'center',
              marginTop: 4,
            }}>
            Home of the world's best coaches, players and the largest
            tournaments.
          </CCText>

          <Box
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: 16,
              marginTop: 32,
            }}>
            {cardData.map((item, index) => (
              <Box
                key={index}
                style={{
                  width: 215,
                  padding: 32,
                  borderRadius: 8,
                  borderWidth: 1,
                  backgroundColor: CCColors?.LightYellow,
                  borderColor: '#DDD8C8',
                }}>
                <Image
                  source={require('@/Assets/Images/Meetings/Pattern.svg')}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: 90,
                    height: 90,
                  }}
                />
                <Image
                  resizeMode="contain"
                  source={item.icon}
                  style={{height: 44, width: 44, marginBottom: 12}}
                />
                <CCText
                  style={{
                    fontSize: 16,
                    fontWeight: '600',
                    lineHeight: 24,
                  }}>
                  {item.title}
                </CCText>
                <CCText
                  style={{
                    fontSize: 14,
                    fontWeight: '400',
                    lineHeight: 20,
                    marginTop: 4,
                    whiteSpace: 'nowrap',
                  }}>
                  {item.desc}
                </CCText>
              </Box>
            ))}
          </Box>

          <Box style={{marginTop: 32}}>
            <CCButton
              style={{
                paddingHorizontal: 32,
                paddingVertical: 12,
                borderRadius: 32,
              }}
              onPress={() =>
                Linking.openURL(
                  'https://circlechess.com/caissa-school-of-chess/',
                )
              }>
              <CCText
                style={{
                  fontSize: 16,
                  fontWeight: '500',
                  lineHeight: 24,
                  color: CCColors?.TextColor?.Dark,
                }}>
                Explore Caissa School of Chess
              </CCText>
            </CCButton>
          </Box>
        </Box>
      );
    }

    return <>
          {showRenewalBanner && renewalData && userData?.is_staff && (
            <Box paddingHorizontal={isMobileOrTab ? 10 : 20} marginBottom={15}>
              <RenewalBanner
                daysLeft={renewalData?.current_subscription?.days_to_expiry}
                couponDiscountPercentage={Number(renewalData?.coupon?.discount_value) ?? 0}
                // daysLeft={-1}
                sessionsLeft={renewalData?.current_subscription?.sessions_left ?? 0} // This should come from API or be calculated
                couponCode={renewalData?.coupon?.code}
                onRenewNow={() => {
                  navigation.navigate(ScreenName.Renewal, {userId});
                }}
                onClose={() => setShowRenewalBanner(false)}
              />
            </Box>
          )}</>;
  };

  const UpcomingWebinars = () => (
    <WebinarSection
      isLoading={isLoading || isWebinarLoading}
      webinarLoading={webinarLoading}
      tableData={upcomingTableData}
      tabHeaders={tabHeaders}
      currentPage={currentPage}
      totalPages={totalPages}
      paginate={paginate}
      webinarDetails={webinarDetails}
      cardData={cardData}
      isMobileOrTab={isMobileOrTab}
    />
  );

  const PastWebinars = () => (
    <WebinarSection
      isLoading={isLoading || isWebinarLoading}
      webinarLoading={webinarLoading}
      tableData={pastTableData}
      tabHeaders={tabHeaders}
      currentPage={currentPage}
      totalPages={totalPages}
      paginate={paginate}
      webinarDetails={webinarDetails}
      cardData={cardData}
      isMobileOrTab={isMobileOrTab}
    />
  );

  const renderScene = (rendererSceneProps: any) => {
    const {route: tempRoute} = rendererSceneProps;
    let returnJSX = <></>;

    switch (tempRoute.key) {
      case 'Meetings':
        return <PastWebinars />;
      case 'Upcoming Meetings':
        return <UpcomingWebinars />;
    }
  };

  useEffect(() => {
    if (
      (webinarData && Array.isArray(webinarData)) ||
      (pastWebinarData && Array.isArray(pastWebinarData))
    ) {
      const itemsPerPage = 10;
      // const allData = [...pastWebinarData, ...webinarData];
      const pastData = [
        ...(pastWebinarData || [])?.map(item => ({...item, isPast: true})),
      ];
      const allData = [
        ...(webinarData || [])?.map(item => ({...item, isPast: false})),
      ];
      const webinars = index === 0 ? pastData : allData;
      const totalItems = webinars?.length;

      setTotalPages(Math.ceil(totalItems / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const hasBeginnerClass = webinars?.some(
        item => item?.batch_type === 'Beginner',
      );
      setEnableClassroom(hasBeginnerClass);
      const paginatedData = webinars?.slice(startIndex, endIndex);
      // Identify today's webinars from ALL data, not just current page
      const todayStr = dayjs().format('YYYY-MM-DD');
      const todayIds = new Set<string>();
      const tomorrowStr = dayjs().add(1, 'day').format('YYYY-MM-DD');
      const tomorrowIds = new Set<string>();
      webinars?.forEach(item => {
        // Create unique key using webinar_id and (occurence not occurrence)_id
        const uniqueKey = `${item?.webinar_id || ''}_${
          item?.occurence_id || ''
        }`;
        if (item?.webinar_date === todayStr) {
          todayIds.add(uniqueKey);
        }
        if (item?.webinar_date === tomorrowStr) {
          tomorrowIds.add(uniqueKey);
        }
      });
      setTodayWebinarIds(todayIds);
      const formattedData = paginatedData?.map((item, index) => {
        const showRescheduleButton = new Date(item.end_time) > new Date();
        const disableCancel =
          !item?.is_zoom_meeting ||
          item?.call_type === 'demo_call' ||
          item?.webinar_date < new Date();
        const webinar_topic = item?.topic;
        const webinarCoach = item?.coach_name;
        const webinar_date = item?.webinar_date;
        const webinar_time = item?.webinar_time;
        const webinar_url = item?.join_url;
        const meeting_info = item?.meeting_info;
        const isStudent =
          item?.user_type !== 'coach' && item?.user_role !== 'mentor';
        const webinar_classtype = isStudent
          ? item?.class_type
          : item?.batch_code && item?.batch_code !== 'none'
          ? item?.batch_code
          : item?.class_type;
        const webinar_id = item?.webinar_id;
        const registrant_token = item?.registrant_token;
        const datetime = convertISTDateTimeToLocal(webinar_date, webinar_time);
        const past_webinar_id = item?.id;
        const status = item?.status;

        // Determine actual status and tooltip for penalty sessions
        let displayStatus = status;
        let statusTooltip: string | null = null;

        // Check if session was held as penalty (cancelled late by student)
        if (item?.held_as_penalty) {
          displayStatus = 'missed';
          statusTooltip =
            'Late cancellation or cancellation limit exceeded - session still counted toward your subscription';
        }

        const uniqueKey = `${item?.webinar_id || ''}_${
          item?.occurence_id || ''
        }`;
        const isGroupSession =
          (item?.call_type === 'meeting' || item?.call_type === 'webinar') &&
          item?.batch_code &&
          item?.batch_code !== 'none' &&
          !item?.batch_code?.toLowerCase()?.includes('-p-');
        const canCancel = !(isGroupSession && isStudent); // Students cannot cancel group sessions
        const shouldShowBottomBox =
          (webinar_url &&
            item?.showJoin &&
            registrant_token &&
            item?.status !== 'rescheduled') ||
          item?.recording_available ||
          (item.showJoin && registrant_token) ||
          (!disableCancel &&
            (item?.was_cancelled ||
              item?.finding_substitute ||
              (canCancel &&
                item?.is_zoom_meeting &&
                item?.call_type !== 'demo_call' &&
                item?.call_type !== 'mentor_call')));

        const isTodayMeeting = todayIds.has(uniqueKey);
        const isTomorrowMeeting = tomorrowIds.has(uniqueKey);
        const showJoin = isTomorrowMeeting || isTodayMeeting;
        let itemValues: any = [];
        // Date
        itemValues.push({
          name: isMobileOrTab ? (
            <Box flexDirection="column" style={styles.wrap}>
              <Box
                flexDirection="row"
                justifyContent="space-between"
                gap={vs(8)}
                style={styles.padw}>
                <Box
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="center"
                  style={{
                    width: '70%',
                  }}>
                  <Box
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent="center"
                    style={{flexWrap: 'nowrap', maxWidth: '90%'}}>
                    <CCText
                      showEllipses={true}
                      color={CCColors.Primary.Brown}
                      fontSize={FontSizes[18]}>
                      {webinar_topic}
                    </CCText>
                    <CCText
                      showEllipses={true}
                      color={CCColors.TextColor.GreyText}
                      fontWeight={400}
                      fontSize={FontSizes[16]}>
                      {webinarCoach}
                    </CCText>
                  </Box>
                  <Box
                    flexDirection="column"
                    gap={vs(3)}
                    style={{paddingTop: vs(8)}}>
                    <Box alignItems="flex-start" gap={5} flexDirection="row">
                      <MaterialCommunityIcons
                        name="clock-outline"
                        fontWeight={500}
                        size={FontSizes[18]}
                        color={CCColors.TextColor.GreyText}
                        style={{
                          paddingTop: vs(2),
                        }}
                      />
                      <CCText
                        fontWeight={500}
                        color={CCColors.TextColor.GreyText}
                        fontSize={FontSizes[14]}>
                        {`${datetime?.localTimeRange.split('GMT')[0]}`}
                        {'\n'}
                        {`GMT${datetime?.localTimeRange.split('GMT')[1]}`}
                      </CCText>
                    </Box>
                    <Box alignItems="center" gap={5} flexDirection="row">
                      <MaterialCommunityIcons
                        fontWeight={500}
                        name="desktop-mac"
                        size={FontSizes[18]}
                        color={CCColors.TextColor.GreyText}
                      />
                      <CCText
                        fontWeight={500}
                        color={CCColors.TextColor.GreyText}
                        fontSize={FontSizes[14]}>
                        {webinar_classtype}
                      </CCText>
                    </Box>
                  </Box>
                </Box>

                <Box style={styles.link} flexDirection="column">
                  <Box
                    gap={7}
                    flexDirection="column"
                    style={[
                      styles.session_link,
                      {
                        borderColor: getStatusStyles(status)?.borderColor,
                        paddingHorizontal: 0,
                      },
                    ]}>
                    <Box
                      type="row-center"
                      gap={10}
                      style={[
                        styles.zoom_box,
                        {
                          backgroundColor:
                            getStatusStyles(status)?.backgroundColor,
                          paddingHorizontal:
                            status === 'rescheduled' ? vs(8) : vs(15),
                          paddingVertical: vs(5),
                        },
                      ]}>
                      <CCText fontWeight={600} color={CCColors.Primary.Brown}>
                        {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
                      </CCText>
                    </Box>
                    <Box style={[styles.datetime]}>
                      <Box style={[styles.monthbox, styles.monthboxsub]}>
                        <CCText
                          style={{
                            padding: vs(2),
                          }}
                          fontSize={FontSizes[15]}
                          color={CCColors.Grey.Grey}
                          textAlign="center"
                          fontWeight="500">
                          {dayjs(datetime?.localDate).format('MMM')}
                        </CCText>
                      </Box>
                      <CCText
                        style={{
                          padding: vs(5),
                        }}
                        textAlign="center"
                        fontWeight="500"
                        fontSize={FontSizes[18]}>
                        {dayjs(datetime?.localDate).get('date')}
                      </CCText>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {shouldShowBottomBox && (
                <Divider
                  width={0.5}
                  style={{
                    backgroundColor: CCColors.BorderLight,
                  }}
                />
              )}
              <Box
                flexDirection="row"
                justifyContent="space-between"
                style={{
                  paddingVertical: vs(8),
                  flexWrap: 'wrap',
                }}>
                {registrant_token || item?.recording_available ? (
                  <Box type="row-flex-start" style={styles.rec}>
                    {item?.recording_available ? (
                      <TouchableOpacity
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 6,
                        }}>
                        <CCButton
                          contentContainerStyle={styles.dark}
                          onPress={() => handleRecordingPress(item)}>
                          <CCText
                            color={CCColors.Primary.Default}
                            fontWeight={600}
                            fontSize={FontSizes[12]}>
                            Relearn
                          </CCText>
                        </CCButton>
                      </TouchableOpacity>
                    ) : (
                      (item?.isPast === true || showJoin) &&
                      webinar_url &&
                      item?.showJoin &&
                      registrant_token &&
                      item?.status !== 'rescheduled' && (
                        <TouchableOpacity style={styles.but}>
                          <CCButton
                            contentContainerStyle={{
                              paddingHorizontal: 70,
                            }}
                            disabled={item?.was_cancelled}
                            onPress={() => {
                              handleJoinPress(item);
                            }}>
                            <CCText fontWeight={600} fontSize={FontSizes[14]}>
                              Join
                            </CCText>
                          </CCButton>
                        </TouchableOpacity>
                      )
                    )}
                  </Box>
                ) : (
                  (item?.isPast === true || showJoin) &&
                  item.showJoin &&
                  registrant_token && (
                    <TouchableOpacity style={styles.but}>
                      <CCButton
                        contentContainerStyle={{
                          paddingHorizontal: 20,
                        }}
                        disabled={item?.was_cancelled}
                        onPress={() => {
                          handleJoinPress(item);
                        }}>
                        <CCText fontWeight={600} fontSize={FontSizes[12]}>
                          Join
                        </CCText>
                      </CCButton>
                    </TouchableOpacity>
                  )
                )}

                <Box
                  alignItems="center"
                  justifyContent="center"
                  style={styles.reschedulebut}>
                  {showRescheduleButton &&
                    ((!item?.was_cancelled &&
                      item?.batch_code?.includes('-P-') &&
                      !userData.is_coach) ||
                      item?.call_type === 'mentor_call') && (
                      <TouchableOpacity
                        onPress={() => handleReschedule(item)}
                        style={styles.handle}>
                        <Box
                          flexDirection="row"
                          justifyContent="center"
                          alignItems="center"
                          gap={2}
                          style={[styles.reschedule]}>
                          <MaterialCommunityIcons
                            name="calendar-refresh-outline"
                            color={CCColors.Black}
                            size={17}
                          />
                        </Box>
                      </TouchableOpacity>
                    )}
                  {disableCancel ? (
                    <></>
                  ) : //  : item?.was_cancelled ? (
                  //   <Box
                  //     style={{
                  //       backgroundColor: CCColors.Grey.Light,
                  //       paddingHorizontal: 12,
                  //       paddingVertical: 6,
                  //       borderRadius: 16,
                  //     }}>
                  //     <CCText
                  //       fontSize={FontSizes[14]}
                  //       color={CCColors.Grey.Grey}>
                  //       Cancelled
                  //     </CCText>
                  //   </Box>
                  // )
                  item?.finding_substitute ? (
                    <Box style={styles.cancelIcon}>
                      <Icon
                        name="cancel"
                        size={24}
                        color={CCColors.Grey.Grey}
                      />
                    </Box>
                  ) : !canCancel ||
                    !item?.is_zoom_meeting ||
                    item?.call_type === 'demo_call' ||
                    item?.call_type === 'mentor_call' ? (
                    <></>
                  ) : (
                    <TouchableOpacity
                      onPress={() => handleCancelClick(item)}
                      style={styles.closeIcon}>
                      <Box
                        flexDirection="row"
                        justifyContent="center"
                        alignItems="center"
                        gap={2}
                        style={styles.cancel}>
                        <MaterialCommunityIcons
                          name="close-circle-outline"
                          color={CCColors.Red}
                          size={17}
                        />
                        {/* <CCText fontWeight={600} color={CCColors.Red}>
                          Cancel
                        </CCText> */}
                      </Box>
                    </TouchableOpacity>
                  )}
                </Box>
              </Box>
            </Box>
          ) : (
            <Box style={styles.dateCard}>
              <Box style={styles.monthbox}>
                <CCText
                  color={CCColors.Grey.Grey}
                  textAlign="center"
                  fontWeight="500">
                  {dayjs(datetime?.localDate).format('MMM')}
                </CCText>
              </Box>
              <CCText
                textAlign="center"
                fontWeight="600"
                fontSize={FontSizes[12]}>
                {dayjs(datetime?.localDate).get('date')}
              </CCText>
            </Box>
          ),
          type: 'text',
        });
        // Webinar Topic
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : (
            <Box
              flexDirection="column"
              alignItems="flex-start"
              justifyContent="center"
              gap={vs(2)}
              style={{
                paddingLeft: hs(8),
                paddingRight: vs(4),
                width: '100%',
                height: '100%',
              }}>
              <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                {webinar_topic}
              </CCText>
              <CCText
                color={CCColors.Grey.Grey}
                fontWeight={600}
                fontSize={FontSizes[12]}>
                {webinarCoach}
              </CCText>
            </Box>
          ),
          type: 'text',
        });
        // Time
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[12]}>
                  {datetime?.localTimeRange}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        // Class Type
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                  {webinar_classtype}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });

        //Status
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : statusTooltip ? (
            <Tooltip
              text={statusTooltip}
              backgroundColor={CCColors.Black}
              textcolor={CCColors.White}
              borderColor={CCColors.Black}
              arrowColor={CCColors.Black}
              fontSize={12}
              width={250}
              height={undefined}
              paddingVertical={8}
              borderWidth={1}
              children={toggleEvent => (
                <View onPointerEnter={toggleEvent} onPointerLeave={toggleEvent}>
                  <Box
                    gap={10}
                    type="row-center"
                    style={[
                      styles.session_link,
                      {
                        borderColor:
                          getStatusStyles(displayStatus)?.borderColor,
                      },
                    ]}>
                    <Box
                      type="row-center"
                      gap={10}
                      style={[
                        styles.zoom_box,
                        {
                          backgroundColor:
                            getStatusStyles(displayStatus)?.backgroundColor,
                          padding: vs(8),
                        },
                      ]}>
                      <CCText fontWeight={600} color={CCColors.Primary.Brown}>
                        {displayStatus?.charAt(0)?.toUpperCase() +
                          displayStatus?.slice(1)}
                      </CCText>
                    </Box>
                  </Box>
                </View>
              )}
            />
          ) : (
            <Box
              gap={10}
              style={[
                styles.session_link,
                {
                  borderColor: getStatusStyles(displayStatus)?.borderColor,
                },
              ]}>
              <Box
                type="row-center"
                gap={10}
                style={[
                  styles.zoom_box,
                  {
                    backgroundColor:
                      getStatusStyles(displayStatus)?.backgroundColor,
                    padding: vs(8),
                  },
                ]}>
                <CCText fontWeight={600} color={CCColors.Primary.Brown}>
                  {displayStatus?.charAt(0)?.toUpperCase() +
                    displayStatus?.slice(1)}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        // Actions (Cancel button or Cancelled tag)
        // Determine if cancel button should be shown
        // Group sessions: call_type is 'meeting' or 'webinar' AND batch_code doesn't contain '-p-'
        // Personal sessions: call_type is 'mentor_call' OR batch_code contains '-p-'
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : (
            <Box
              alignItems="center"
              justifyContent="flex-start"
              style={{
                marginLeft: 18,
                flexWrap: 'wrap',
              }}
              flexDirection="row">
              <Box flexDirection="row" alignItems="center">
                {registrant_token || item?.recording_available ? (
                  <Box
                    style={{
                      height: '100%',
                    }}>
                    <Box
                      type="row-flex-start"
                      style={{
                        marginRight: 8,
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                        alignItems: 'center',
                        // justifyContent: 'row-center',
                      }}>
                      {item?.recording_available ? (
                        <CCButton
                          contentContainerStyle={{
                            paddingHorizontal: 20,
                            backgroundColor: CCColors.Primary.Dark,
                          }}
                          onPress={() => handleRecordingPress(item)}>
                          <CCText
                            color={CCColors.Primary.Default}
                            fontWeight={600}
                            fontSize={FontSizes[12]}>
                            Relearn
                          </CCText>
                        </CCButton>
                      ) : (
                        (item?.isPast === true || showJoin) &&
                        webinar_url &&
                        item?.showJoin &&
                        registrant_token &&
                        item?.status !== 'rescheduled' && (
                          <TouchableOpacity
                            style={{
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            <CCButton
                              contentContainerStyle={{
                                paddingHorizontal: 20,
                              }}
                              disabled={item?.was_cancelled}
                              onPress={() => {
                                handleJoinPress(item);
                              }}>
                              <CCText fontWeight={600} fontSize={FontSizes[12]}>
                                Join
                              </CCText>
                            </CCButton>
                          </TouchableOpacity>
                        )
                      )}
                    </Box>
                  </Box>
                ) : (
                  (item?.isPast === true || showJoin) &&
                  item.showJoin &&
                  registrant_token && (
                    <TouchableOpacity style={styles.circle}>
                      <CCButton
                        contentContainerStyle={{
                          paddingHorizontal: 20,
                        }}
                        disabled={item?.was_cancelled}
                        onPress={() => {
                          handleJoinPress(item);
                        }}>
                        <CCText fontWeight={600} fontSize={FontSizes[12]}>
                          Join
                        </CCText>
                      </CCButton>
                    </TouchableOpacity>
                  )
                )}
                {item?.status == 'cancelled' && item?.detail_reason && (
                  <CCButton
                    contentContainerStyle={styles.custom}
                    style={styles.cusbor}
                    onPress={() => {
                      openAlertModal({
                        bodyTxt: item?.detail_reason?.reason,
                        buttonText: 'Okay',
                        header: 'Reason',
                      });
                    }}>
                    <CCText color={CCColors.Black} fontWeight={600}>
                      View Detail
                    </CCText>
                  </CCButton>
                )}
              </Box>
              <Box
                alignItems="center"
                style={{
                  marginLeft: 8,
                  height: '100%',
                }}>
                <Box
                  alignItems="center"
                  justifyContent="center"
                  style={styles.tool}>
                  {showRescheduleButton &&
                    ((!item?.was_cancelled &&
                      item?.batch_code?.includes('-P-') &&
                      !userData.is_coach) ||
                      item?.call_type === 'mentor_call') && (
                      <Tooltip
                        text={'Reschedule Session'}
                        backgroundColor={CCColors.Black}
                        textcolor={CCColors.White}
                        borderColor={CCColors.Black}
                        arrowColor={CCColors.Black}
                        fontSize={12}
                        width={250}
                        height={undefined}
                        paddingVertical={8}
                        borderWidth={1}
                        children={toggleEvent => (
                          <View
                            onPointerEnter={toggleEvent}
                            onPointerLeave={toggleEvent}>
                            <TouchableOpacity
                              onPress={() => handleReschedule(item)}
                              style={[
                                styles.handle,
                                {
                                  cursor: 'pointer',
                                },
                              ]}>
                              <Box
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                style={styles.reschedule}>
                                <MaterialCommunityIcons
                                  name="calendar-refresh-outline"
                                  color={CCColors.Black}
                                  size={17}
                                />
                              </Box>
                            </TouchableOpacity>
                          </View>
                        )}
                      />
                    )}
                  {disableCancel ? (
                    <></>
                  ) : item?.finding_substitute ? (
                    <Box
                      style={[
                        styles.cancelIcon,
                        {
                          cursor: 'pointer',
                        },
                      ]}>
                      <Icon
                        name="cancel"
                        size={24}
                        color={CCColors.Grey.Grey}
                      />
                    </Box>
                  ) : !canCancel ||
                    !item?.is_zoom_meeting ||
                    item?.call_type === 'demo_call' ||
                    item?.call_type === 'mentor_call' ? (
                    <></>
                  ) : (
                    <Tooltip
                      text={'Cancel Session'}
                      backgroundColor={CCColors.Black}
                      textcolor={CCColors.White}
                      borderColor={CCColors.Black}
                      arrowColor={CCColors.Black}
                      fontSize={12}
                      width={250}
                      height={undefined}
                      paddingVertical={8}
                      borderWidth={1}
                      children={toggleEvent => (
                        <View
                          onPointerEnter={toggleEvent}
                          onPointerLeave={toggleEvent}>
                          <TouchableOpacity
                            onPress={() => handleCancelClick(item)}
                            style={[
                              styles.handle,
                              {
                                cursor: 'pointer',
                              },
                            ]}>
                            <Box
                              flexDirection="row"
                              justifyContent="center"
                              alignItems="center"
                              gap={2}
                              style={styles.cancel}>
                              <MaterialCommunityIcons
                                name="close-circle-outline"
                                color={CCColors.Red}
                                size={17}
                              />
                            </Box>
                          </TouchableOpacity>
                        </View>
                      )}
                    />
                  )}
                  {item?.assignment && (
                    <Tooltip
                      text={'Assignment'}
                      backgroundColor={CCColors.Black}
                      textcolor={CCColors.White}
                      borderColor={CCColors.Black}
                      arrowColor={CCColors.Black}
                      fontSize={12}
                      width={250}
                      height={undefined}
                      paddingVertical={8}
                      borderWidth={1}
                      children={toggleEvent => (
                        <View
                          onPointerEnter={toggleEvent}
                          onPointerLeave={toggleEvent}>
                          <TouchableOpacity
                            onPress={() => {
                              navigation.navigate(ScreenName?.Books, {
                                tab: 'user_assignment',
                                name: item?.assignment?.name,
                                bookKey: item?.assignment?.book_key,
                                fromTab: 'meetings',
                              });
                            }}
                            style={[
                              styles.handle,
                              {
                                cursor: 'pointer',
                              },
                            ]}>
                            {item?.assignment?.completed === true ? (
                              <Box
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                style={[
                                  styles.reschedule,
                                  {
                                    borderColor: CCColors.BlueAqua,
                                    backgroundColor:
                                      CCColors.StatusBar.BorderAquaBlue,
                                  },
                                ]}>
                                <Image
                                  source={bookOpen}
                                  style={{
                                    width: 16,
                                    height: 16,
                                  }}
                                />
                              </Box>
                            ) : (
                              <Box
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                style={[
                                  styles.reschedule,
                                  {
                                    borderColor: CCColors.Primary.Dark,
                                    backgroundColor: CCColors.Primary.Dark,
                                  },
                                ]}>
                                <Image
                                  source={bookCheck}
                                  style={{
                                    width: 16,
                                    height: 16,
                                  }}
                                />
                              </Box>
                            )}
                          </TouchableOpacity>
                        </View>
                      )}
                    />
                  )}
                  {item?.lms_chapter_link && (
                    <Tooltip
                      text={'Study Notes'}
                      backgroundColor={CCColors.Black}
                      textcolor={CCColors.White}
                      borderColor={CCColors.Black}
                      arrowColor={CCColors.Black}
                      fontSize={12}
                      width={250}
                      height={undefined}
                      paddingVertical={8}
                      borderWidth={1}
                      children={toggleEvent => (
                        <View
                          onPointerEnter={toggleEvent}
                          onPointerLeave={toggleEvent}>
                          <TouchableOpacity
                            onPress={() =>
                              navigation.navigate(ScreenName?.Courses, {
                                directCourseId: item?.lms_chapter_link?.uuid, // Your course UUID
                                chapter: item?.lms_chapter_link?.chapter, // Your chapter ID
                                autoOpen: true, // Flag to auto-open iframe
                                returnUrl: `${window.location.origin}/resources?tab=meeting`,
                              })
                            }
                            style={[
                              styles.handle,
                              {
                                cursor: 'pointer',
                              },
                            ]}>
                            <Box
                              flexDirection="row"
                              justifyContent="center"
                              alignItems="center"
                              gap={2}
                              style={[
                                styles.reschedule,
                                {
                                  borderColor: CCColors.Primary.Dark,
                                  backgroundColor: CCColors.Primary.Dark,
                                },
                              ]}>
                              <MaterialCommunityIcons
                                size={16}
                                name="clipboard-text-outline"
                                color={CCColors.Primary.Default}
                              />
                            </Box>
                          </TouchableOpacity>
                        </View>
                      )}
                    />
                  )}
                </Box>
              </Box>
            </Box>
          ),
          type: 'link',
        });
        return {
          data: itemValues,
          isToday: isTodayMeeting,
          itemId: uniqueKey,
        };
      });
      // At the end, set the appropriate state
      if (index === 0) {
        setPastTableData(formattedData || []);
      } else {
        setUpcomingTableData(formattedData || []);
      }
    }
  }, [currentPage, isMobileOrTab, webinarData, pastWebinarData, index]);

  const cardData = [
    {
      title: 'Live Classes',
      desc: 'Live IM/GM Classes',
      icon: require('@/Assets/Images/Meetings/Instructor.svg'),
    },
    {
      title: 'Coach',
      desc: 'Personalized training',
      icon: require('@/Assets/Images/Meetings/Coach.svg'),
    },
    {
      title: 'Mentor',
      desc: '1-on-1 Mentor Sessions',
      icon: require('@/Assets/Images/Meetings/Mentor.svg'),
    },
    {
      title: 'Practice',
      desc: 'Learn, compete, & grow',
      icon: require('@/Assets/Images/Meetings/Practice.svg'),
    },
  ];

  return (
    <>
      <LinkModal
        showConfirm={showPopup}
        handleCtaTitle1Press={handleCTA1Press}
        errorMessage={undefined}
        handleCtaTitle2Press={handleCTA2Press}
        iconImage={
          <MaterialCommunityIcons
            name={popupConfig?.icon}
            color={CCColors.White}
            size={30}
          />
        }
        ctaTitle1={popupConfig?.cta1?.text}
        ctaTitle2={popupConfig?.cta2?.text}
        titleText={popupConfig?.questionText}
        description={popupConfig?.subQuestionText}
        highlight1={popupConfig?.cta1?.highlight}
        highlight2={popupConfig?.cta2?.highlight}
        handleClose={() => setShowPopup(false)}
        backgroundColor={ICON_MAP?.[popupData?.icon]?.bgColor}
        borderColor={ICON_MAP?.[popupData?.icon]?.bgColor}
      />
      <CCLoader loading={activeLoading || endLoading} />
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{paddingHorizontal: 20}}>
        {sessionClick && (
          <SlideModal
            visible={sessionClick}
            type="center"
            customStyle={styles.reason}>
            <PopUp
              confirm={async () => {
                markWebinarHeld({was_held: true, id: pastWebinarId});
                setSessionClick(false);
              }}
              text={'Are you sure you want to mark this session as held?'}
              buttonConfirm="Confirm"
              cancel={() => setSessionClick(false)}
            />
          </SlideModal>
        )}
        {showErrorAlert && (
          <SlideModal
            visible={showErrorAlert}
            type="center"
            customStyle={styles.reason}>
            <PopUp
              confirm={async () => {
                setShowErrorAlert(false);
              }}
              text={popupText}
              buttonConfirm="Okay"
            />
          </SlideModal>
        )}
        <Spacer spacing={vs(16)} />
        <Box
          type={isMobileOrTab ? 'column' : 'row-center-between'}
          style={{
            width: '100%',
          }}>
          {/* <CCLoader loading={isWebinarLoading} /> */}

          
            <TabView
              lazy
              // @ts-ignore
              navigationState={{index: index, routes}}
              renderScene={renderScene}
              animationEnabled={false}
              renderTabBar={props => {
                const {navigationState} = props;
                const {index: activeIndex, routes} = navigationState;

                return (
                  <Box
                    justifyContent="flex-start"
                    flexDirection={isMobileOrTab ? 'column' : 'row'}
                    gap={isMobileOrTab && 20}
                    style={{
                      marginBottom: 18,
                    }}>
                      
                    <Box>
                      <CCText fontSize={24} color={CCColors.Primary.Dark}>
                        Meetings
                      </CCText>
                    </Box>
                    {showStatusBar && isMobileOrTab && (
                      <LinearGradient
                        colors={['#E17846', '#e0850f']}
                        start={{x: 1, y: 0}}
                        end={{x: 0, y: 0}}
                        style={styles.grad}>
                        <MeetingsBanner
                          backgroundColor={statusBanner?.iconBg}
                          iconName={statusBanner?.icon}
                          iconColor={statusBanner?.iconColor}
                          onClose={() => setShowStatusBar(false)}
                          titleText={statusBanner?.title}
                          ctaText={statusBanner?.ctaTitle}
                          closeIcon={statusBanner?.closeIcon}
                          handlePress={handleStatusBarPress}
                          borderColor={statusBanner?.iconColor}
                          subtitleText={statusBanner?.subTitle}
                          highlight={statusBanner?.highlight}
                          textColor={CCColors.White}
                        />
                      </LinearGradient>
                    )}
                    <Box
                      flexDirection="row"
                      alignItems="center"
                      // justifyContent="flex-end"
                      style={{
                        width: '90%',
                        justifyContent: 'flex-end',
                      }}
                      gap={8}>
                      <TabBar
                        {...props}
                        indicatorStyle={{
                          width: '50%',
                          height: '100%',
                          backgroundColor: CCColors.Primary.Brown,
                          borderTopLeftRadius:
                            props?.navigationState?.index === 0 ? 8 : 0, // Rounded for first tab
                          borderBottomLeftRadius:
                            props?.navigationState?.index === 0 ? 8 : 0,
                          borderTopRightRadius:
                            props?.navigationState?.index ===
                            props?.navigationState?.routes?.length - 1
                              ? 8
                              : 0, // Rounded for last tab
                          borderBottomRightRadius:
                            props?.navigationState?.index ===
                            props?.navigationState?.routes?.length - 1
                              ? 8
                              : 0,
                        }}
                        style={[
                          styles.ner,
                          {
                            width: isMobileOrTab ? '100%' : '33%',
                          },
                        ]}
                        contentContainerStyle={{
                          height: 32, // Set the height for the tablist
                        }}
                        renderLabel={({route, focused, ...rest}) => {
                          const totalItems =
                            props?.navigationState?.routes?.length;
                          const itemId =
                            props?.navigationState?.routes?.findIndex(
                              i => i?.key === route?.key,
                            );

                          return (
                            <CCText
                              fontSize={FontSizes[12]}
                              fontWeight="semibold"
                              style={[
                                styles.boxTabBarLabel,
                                focused ? styles.boxIndicator : {},
                                {
                                  color: focused
                                    ? CCColors?.White
                                    : CCColors?.TextColor?.Primary,
                                },
                                itemId === 0
                                  ? styles.boxLeftBorder
                                  : itemId === totalItems - 1
                                  ? styles.boxRightBorder
                                  : null,
                              ]}>
                              {route.title}
                            </CCText>
                          );
                        }}
                        tabStyle={styles.index}
                      />
                    </Box>
                  </Box>
                );
              }}
              onIndexChange={index => {
                setIsTabChanging(true);
                setIndex(index);
                setCurrentPage(1);
              }}
            />
          
          {isMobileOrTab && <Spacer spacing={10} />}
        </Box>
        <Spacer spacing={vs(20)} />
      </ScrollView>
      <ActiveMeetingsModal
        visible={showActiveMeetingsModal}
        activeMeetingsCount={activeMeetingsCount || 0}
        onClose={handleModalClose}
        onJoin={handleModalJoin}
        onEndAndJoin={handleModalEndAndJoin}
      />
      <CancelSessionModal
        visible={showCancelModal}
        sessionData={cancelSessionData}
        onClose={() => {
          setShowCancelModal(false);
          setCancelSessionData(null);
        }}
        onConfirm={handleCancelConfirm}
        isLoading={isCancelling}
        userRole={userRole}
      />
      <RescheduleModal
        visible={showRescheduleModal}
        onClose={() => {
          setShowRescheduleModal(false);
          setCallId('');
        }}
        isLoading={
          isMentorCall
            ? isMentorSlotsLoading || isRescheduleMentorCallLoading
            : isCoachSlotsLoading || isRescheduleSessionLoading
        }
        availableSlots={coachAvailableSlots}
        isHost={userData.is_mentor}
        callId={callId}
        onReschedule={isMentorCall ? rescheduleMentorCall : rescheduleSession}
        userTimezone={userTimezone}
        apiResponse={rescheduleSessionResponse}
      />
    </>
  );
};

const styles = StyleSheet.create({
  boxLeftBorder: {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  boxRightBorder: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  boxIndicator: {
    // backgroundColor: CCColors?.Primary.Brown,
    height: '0%',
    marginBottom: 20,
    // borderRadius: 8,
  },
  boxTabBarLabel: {
    color: CCColors?.White,
    paddingBottom: 55,
    // borderWidth: StyleSheet.hairlineWidth,
  },
  statusBar: {
    paddingVertical: '0.5%',
    borderRadius: 8,
  },
  dateCard: {
    backgroundColor: CCColors.White,
    borderRadius: 8,
    padding: vs(4),
    marginLeft: vs(25),
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#26232233',
    shadowColor: '#4D3F370D',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
    marginVertical: vs(5),
  },
  monthbox: {
    backgroundColor: CCColors.Primary.Light,
    borderRadius: 4,
    width: '100%',
    marginBottom: vs(4),
  },
  session_link: {
    borderWidth: 0,
    borderColor: '#67B3E180',
    borderRadius: 4,
    paddingVertical: vs(6),
    paddingHorizontal: vs(10),
    color: CCColors.Primary.Dark,
  },
  zoom_box: {
    backgroundColor: '#67B3E126',
    borderRadius: 4,
    paddingVertical: vs(10),
    paddingHorizontal: vs(15),
    color: CCColors.Primary.Dark,
  },
  table: {
    backgroundColor: CCColors.White,
    borderRadius: 8,
    shadowColor: CCColors.Black,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 6,
    margin: 10,
    overflow: 'hidden',
  },
  mobileTable: {
    backgroundColor: CCColors.CCTableBg,
    borderRadius: 8,
    margin: 0,
    overflow: 'hidden',
  },
  cancel: {
    paddingHorizontal: vs(10),
    paddingVertical: vs(10),
    borderRadius: 25,
    borderWidth: 1,
    borderColor: '#E1784680',
  },
  reschedule: {
    borderColor: CCColors.BorderBottom,
    paddingHorizontal: vs(10),
    paddingVertical: vs(10),
    borderRadius: 25,
    borderWidth: 1,
  },
  wrap: {
    width: '100%',
    paddingHorizontal: vs(17),
    paddingTop: vs(10),
  },
  padw: {
    paddingVertical: vs(12),
    width: '100%',
  },
  link: {
    width: '30%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  datetime: {
    backgroundColor: CCColors.White,
    borderRadius: 8,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: CCColors.ShadowBorder,
    shadowColor: CCColors.Shadow,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
  },
  monthboxsub: {
    marginTop: vs(3),
    marginHorizontal: vs(3),
    width: '95%',
  },
  rec: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dark: {
    paddingHorizontal: 70,
    backgroundColor: CCColors.Primary.Dark,
  },
  but: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 6,
  },
  reschedulebut: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
  },
  handle: {
    padding: 6,
    borderRadius: 4,
    backgroundColor: 'transparent',
  },
  cancelIcon: {
    padding: 6,
    borderRadius: 4,
    backgroundColor: 'transparent',
    opacity: 0.5,
  },
  closeIcon: {
    padding: 6,
    borderRadius: 4,
    backgroundColor: 'transparent',
  },
  circle: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  custom: {
    paddingHorizontal: 20,
    backgroundColor: CCColors.White,
  },
  cusbor: {
    borderColor: '#b6b3b3',
    borderWidth: 1,
  },
  tool: {
    margin: 'auto',
    width: '100%',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
  },
  reason: {
    borderRadius: 12,
    backgroundColor: 'white',
    zIndex: 5,
    overflowY: 'hidden',
    minWidth: '20%',
    margin: 'auto',
  },
  grad: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderWidth: 1,
    borderColor: CCColors.Primary.Brown,
    overflow: 'hidden',
    borderRadius: 8,
  },
  ner: {
    backgroundColor: CCColors?.White,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: CCColors.Grey.Border,
    padding: 0,
    borderRadius: 8,
  },
  index: {
    flex: 1,
    height: '100%',
    paddingTop: 45,
    alignItems: 'center',
    justifyContent: 'center',
    borderRightWidth: 2,
    borderRightColor: CCColors.BorderLight,
  },
  row: {
    backgroundColor: CCColors.Primary.Default,
    borderRadius: 10,
    padding: 8,
    alignItems: 'center',
  },
});

export default Meetings;
